module.exports = __webpack_public_path__ + "media/dashboard/assets/images/bank/sampoerna-logo-7a16892def3994e458f40c1ec36a6051.png";